export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($userId: ID!) {
    getUserProfile(userId: $userId) {
      userId
      name
      phone
      preferredUnits
      city
      state
      country
      createdAt
      updatedAt
    }
  }
`;

export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      userId
      name
      phone
      preferredUnits
      city
      state
      country
      createdAt
      updatedAt
    }
  }
`;
